var exports = {
  "Qs": "x4ddf2309--a3d5da--content",
  "Sl": "x4ddf2309--a3d5da--image",
  "Qq": "x4ddf2309--a3d5da--text",
  "R_": "x4ddf2309--a3d5da--heading",
  "x6": "x4ddf2309--a3d5da--button",
};

module.exports = exports;
